'use client';

import { YouTubeEmbed } from '@next/third-parties/google';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FaqBanner } from './faq-banner.component';

import { ContentContainer } from '@/components/ui/content-container.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Typography } from '@/components/ui/typography/typography.component';

export function AboutUsBanner() {
  return (
    <ContentContainer>
      <Typography variant={TypographyVariant.TITLE} className="mt-6">
        Sobre nós
      </Typography>

      <div className="flex flex-wrap-reverse xl:grid xl:grid-cols-2 items-start gap-5 md:gap-8 xl:gap-11 mt-5">
        <FaqBanner />

        <div className="w-full aspect-video rounded-xl">
          <YouTubeEmbed
            data-testid={DataTestIdEnum.ABOUT_US_YOUTUBE_EMBED}
            videoid="H3xCPEYfogs"
            style="width: 100%; height: 100%; border-radius: 1rem;"
          />
        </div>
      </div>
    </ContentContainer>
  );
}
